<template>
  <div></div>
</template>
<script>
import { mapMutations } from "vuex";
import account from "../services/account";
export default {
  data() {
    return {};
  },
  mounted() {
    let token = this.$route.query.token;
    let path = this.$route.query.path;
    console.log(token)
    this.setToken(token);
    this.getUserInfo();
  },
  methods: {
    ...mapMutations("account", ["setUser", "setToken"]),
    getUserInfo() {
      account.getUserInfo().then((res) => {
        this.setUser(res.data);
        this.$router.push("/");
      });
    },
  },
};
</script>
